module.exports = __webpack_public_path__ + "static/media/Inspectiondue.17ae01bf.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Inspectiondue.PNG
// module id = 2304
// module chunks = 0